export enum ERequestHistoryType {
  Comment = 'comment',
  RequestCreated = 'request_created',
  RequestProcessing = 'request_processing',
  RequestCancelled = 'request_cancelled',
  RequestDelivered = 'request_delivered',
  SupplyAddedToRequest = 'supply_added_to_request',
  SupplyStatusChanged = 'supply_status_changed',
  SupplyPriceChanged = 'supply_price_changed',
}
